import { useMemo, useRef } from 'react';
import { useTranslation } from 'react-i18next';

export function useTranslate(initialWords: string[]) {
	const currentWords = useRef(initialWords);

	const { t } = useTranslation();

	const translations = useMemo(
		() =>
			currentWords.current.reduce(
				(items, key) => ({
					...items,
					[key]: t(key),
				}),
				{} as any,
			),
		[t],
	);

	return {
		...translations,
	} as { [key: string]: string };
}
